import React, {Fragment} from 'react';

import {FolderLink} from './FolderLink';

import {ConnectionFieldSerializedType} from 'sweet-types';

type Props = {
  items: Array<ConnectionFieldSerializedType>;
};

export const ItemRelationsConnection = ({items}: Props) =>
  items != null && items.length > 0 ? (
    <Fragment>
      {items
        .filter((connection) => connection.folder != null)
        .map((connection: ConnectionFieldSerializedType) =>
          // One day the type system will be smart enough to know connection.folder is now never null
          connection.folder != null ? (
            <FolderLink
              key={connection.folder.html_url || connection.folder.name}
              name={connection.folder.name}
              hashid={connection.folder.hashid}
              html_url={connection.folder.html_url}
              className="mr-1 badge badge-light"
              icon={true}
            />
          ) : null
        )}
    </Fragment>
  ) : null;
